import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelDto.mjs'

export const FormItemIsDr = props => (
    <FormItemBizProp
        Model={Model}
        prop="isDr"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={[['0', '否'], ['1', '是']]}
        />
    </FormItemBizProp>
)

export const FormItemDtoName = props => (
    <FormItemBizProp
        Model={Model}
        prop="dtoName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemDtoUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="dtoUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDto(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDtoUserCode />
            <FormItemDtoName />
            <FormItemIsDr />
        </FormChooseDesign>
    )
}
